// futon ページの写真シーン切り替え
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  switch(event) {
    const i = +event.currentTarget.dataset.i
    this.element.querySelectorAll(".shot").forEach((s) => s.classList.toggle("on", +s.dataset.i === i))
    this.element.querySelectorAll(".shot-tabs button").forEach((b) => b.classList.toggle("active", b === event.currentTarget))
  }
}
